// Biodeal Animal Health — Cold Chain & Vaccine Carrier Range
// Source: User brief (protected brand list). Full specifications available on request.

export const COLD_CHAIN_CATEGORIES = [
  { id: "refrigerators", label: "Vaccine Refrigerators" },
  { id: "carriers", label: "Vaccine Carriers" },
  { id: "monitoring", label: "Temperature Monitoring" },
];

export const COLD_CHAIN_PRODUCTS = [
  {
    id: "haier-hyc-68a",
    name: "Haier HYC-68A",
    category: "refrigerators",
    type: "Pharmacy / Vaccine Refrigerator",
    short:
      "Compact medical-grade refrigerator for clinic-level vaccine storage.",
    field_note:
      "Maintains controlled temperature for vaccine and biological storage. Full specifications, ratings and warranty terms available on request from the Biodeal Animal Health technical team.",
  },
  {
    id: "haier-hzy-15z",
    name: "Haier HZY-15Z",
    category: "carriers",
    type: "Vaccine Carrier",
    short:
      "Mid-capacity insulated vaccine carrier for field transport.",
    field_note:
      "Use with the recommended ice packs. Full carrying capacity and cold-life duration available on request.",
  },
  {
    id: "haier-hzy-8z",
    name: "Haier HZY-8Z",
    category: "carriers",
    type: "Vaccine Carrier",
    short:
      "Compact vaccine carrier for short-route field visits and small batches.",
    field_note:
      "Ideal for routine farm visits and small-scale vaccination rounds. Full specifications available on request.",
  },
  {
    id: "haier-hzy-5b",
    name: "Haier HZY-5B",
    category: "carriers",
    type: "Vaccine Carrier",
    short:
      "Portable vaccine carrier — light field configuration.",
    field_note:
      "Compact form factor suited to single-day outreach work. Full specifications available on request.",
  },
  {
    id: "haier-hzy-35b",
    name: "Haier HZY-35B",
    category: "carriers",
    type: "Vaccine Carrier",
    short:
      "Larger-capacity carrier for multi-stop vaccination rounds and outreach campaigns.",
    field_note:
      "Suitable for full-day campaigns and multi-farm vaccination rounds. Full specifications available on request.",
  },
  {
    id: "haier-temp-logger",
    name: "Haier Electronic Temperature Logger",
    category: "monitoring",
    type: "Cold Chain Monitoring",
    short:
      "Electronic temperature logger for cold-chain verification and audit.",
    field_note:
      "Logs temperature continuously for cold-chain compliance. Full data export and configuration details available on request.",
  },
];
